import React from 'react';
import styles from './Preview.module.scss';
import { parseContent } from '../../utils';
import DOMPurify from 'dompurify';

const Preview = ({ form, htmlContent }) => {
  const value = parseContent(form?.getFieldsValue(), htmlContent);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>Предпросмотр</div>
        <div
          className={styles.boxView}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(value?.replace(/\n/g, '<br />')),
          }}
        />
      </div>
    </div>
  );
};
export default Preview;
